import { ReactElement } from "react";
import { AnimatePresence, motion } from 'framer-motion'
import { Button } from "../Button/Button";
import { X } from "lucide-react";
import { List } from "components/List/List";
import { useNavigate } from "react-router-dom";



export interface SidebarProps {
    selectId?: any
    className?: string
    isSidebarOpen?: boolean
    icon?: ReactElement
    setIsSidebarOpen?: (value?: boolean) => void
    sideItems?: ListItemType[]
    position?: "fixed" | "absolute" | "relative"
    onClick?: (value?: ListItemType) => void
    showLabel?: boolean
}



export const Sidebar = ({ showLabel = true, isSidebarOpen = true, position = "relative", icon = <>icon</>, ...props }: SidebarProps): ReactElement => {


    const navigate = useNavigate();


    return <>
        <AnimatePresence>
            {isSidebarOpen && <motion.aside
                initial={{ x: '-100%' }}
                animate={{ x: 0 }}
                exit={{ x: '-100%' }}
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                className={position + (position !== "relative" && " shadow-lg ") + (showLabel ? " w-64 " : " w-24 ") + "      h-full  left-0 top-0 bottom-0 z-30  " + props.className}
            >
                <div className={`flex border-b-2  px-2    ${showLabel ? "justify-between" : " justify-center "} items-center h-16 `}>
                    <div className="text-xl text-black font-bold ">{icon}</div>

                    {position !== "relative" && <Button
                        onClick={() => props.setIsSidebarOpen?.(false)}
                        className=" p-1 text-red-500 "
                    > <X /> </Button>}
                </div>


                {showLabel && <List
                    selectId={props.selectId}
                    onClick={props.onClick}
                    items={props.sideItems}
                />}

                {!showLabel && <div className="  hidden md:block      " >


                    {props.sideItems?.map((node, index) => <div
                        onPointerEnter={() => {
                            const element = document.getElementById(node?.label + "" + index)
                            if (element?.style) {
                                element.style.padding = "4px";
                                element.style.scale = "1"

                            }
                        }}

                        onPointerLeave={() => {
                            const element = document.getElementById(node?.label + "" + index)
                            if (element?.style) {
                                element.style.padding = "0px";
                                element.style.scale = "0"


                            }
                        }}

                        title={node.label}
                        onClick={() => {
                            if (node?.url) {
                                navigate(node.url)
                            } else {
                                props.onClick?.(node)
                                // getSubjects({couresId:e.node?.data?.id})

                            }
                        }}
                        className={" relative flex text-primary cursor-pointer hover:bg-primary/40  justify-center items-center p-3  "}
                        key={index}
                    >
                        {node.icon && <node.icon className="h-5 w-5" />}

                        <div style={{ scale: "0" }} className=" absolute z-[100] w-[100px] top-0  text-center border  -end-[100px] backdrop-blur-sm shadow   duration-100 bg-white/60 rounded    " id={node?.label + "" + index} >
                            {node.label}
                        </div>
                    </div>)}
                </div>}

            </motion.aside>}
        </AnimatePresence>
    </>
}